import { Table, Button, Container } from 'react-bootstrap';
import classes from '../WebsiteManagement/websiteManagement.module.css';
import React, { Fragment, useState, useEffect, useMemo } from 'react';
import Page from '../pagination/pagination';
import { GetCustomers } from '../../entities/action/action';

const postPerPage = 20;

const normalizeSearch = (v) => (v == null ? '' : String(v)).toLowerCase();

const getCustomerDisplayName = (data) => {
  const first = (data.firstName || '').trim();
  const last = (data.lastName || '').trim();
  const full = [first, last].filter(Boolean).join(' ');
  return full || 'Not Available';
};

const CustomerList = (props) => {
  const [dataSet, updateDataSet] = useState([]);
  const [search, updateSearch] = useState('');
  const [currentPage, updateCurrentPage] = useState(1);

  const filteredData = useMemo(() => {
    const q = normalizeSearch(search).trim();
    if (!q) return dataSet;
    return dataSet.filter((data) => {
      const id = normalizeSearch(data.id);
      const email = normalizeSearch(data.email);
      const phone = normalizeSearch(data.phone);
      const firstName = normalizeSearch(data.firstName);
      const lastName = normalizeSearch(data.lastName);
      const fullName = `${firstName} ${lastName}`.trim();
      return (
        id.includes(q) ||
        email.includes(q) ||
        phone.includes(q) ||
        firstName.includes(q) ||
        lastName.includes(q) ||
        fullName.includes(q)
      );
    });
  }, [dataSet, search]);

  const indexOfLast = currentPage * postPerPage;
  const indexOfFirst = indexOfLast - postPerPage;
  const currentPosts = filteredData.slice(indexOfFirst, indexOfLast);
  const pageCount = Math.max(1, Math.ceil(filteredData.length / postPerPage));

  useEffect(() => {
    updateCurrentPage(1);
  }, [search]);

  useEffect(() => {
    (async () => {
      const res = await GetCustomers();
      if (res.success && res?.users !== undefined) {
        updateDataSet(res?.users);
      }
    })();
  }, []);

  const handleChangePage = (event, value) => {
    updateCurrentPage(value);
  };

  return (
    <Fragment>
      <div className="container">
        <Container
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '20px 0',
          }}
        >
          <form
            style={{ display: 'flex', alignItems: 'stretch', width: '50vw' }}
          >
            <input
              placeholder="Name / Email / Phone / Customer Id"
              type="search"
              name="customerSearch"
              autoComplete="off"
              dir="auto"
              className="SearchField"
              onChange={(e) => updateSearch(e.target.value)}
              value={search}
              style={{
                flex: 1,
                minWidth: 0,
                position: 'relative',
                verticalAlign: 'top',
                borderRadius: '1.571em 0 0 1.571em',
                border: '2px solid steelblue',
              }}
            />
          </form>
        </Container>
        <Table responsive>
          <thead>
            <tr>
              <th>S No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.map((data, key) => (
              <tr key={data.id || key}>
                <td>{indexOfFirst + key + 1}</td>
                <td>{getCustomerDisplayName(data)}</td>
                <td>{data.email ?? ''}</td>
                <td>{data.phone ?? ''}</td>
                <td className={classes.CenterRow}>
                  <Button style={{ marginLeft: '-50px' }} onClick={() => props.click(data)}>
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
          <Page count={pageCount} change={handleChangePage} page={currentPage} />
        </div>
      </div>
    </Fragment>
  );
};

export default CustomerList;
